import React from "react";
import Layout from "../../Components/Global/Layout";
const TaxPage = () => {
    return (
        <Layout>
           
        </Layout>
    )
}
export default TaxPage;